import React from 'react';
import { Flex, TextV2 } from '@withjoy/joykit';
import { useLayout } from '../../layouts/LayoutProvider';
import { ReservedRoomBlock } from '../../widgets/Custom/Custom.types';

interface HotelTileProps extends ReservedRoomBlock {}

const HotelTile: React.FC<HotelTileProps> = ({ displayName }) => {
  const { layout } = useLayout();
  const isBrannan = layout === 'brannan';
  return (
    <Flex paddingTop={isBrannan ? { _: 8, sm2: 0 } : 8} paddingBottom={8} width={'100%'}>
      <Flex
        height={597}
        maxWidth={isBrannan ? 520 : 500}
        minWidth={327}
        width={'100%'}
        background={'radial-gradient(circle at 18.7% 37.8%, rgb(250, 250, 250) 0%, rgb(225, 234, 238) 90%);'}
        borderRadius={'8px'}
      >
        <Flex width={'100%'} paddingTop={6}>
          <TextV2 width={'100%'} fontFamily={'Inter UI'} fontSize={'18px'} fontWeight={600} lineHeight={'23.4px'} letterSpacing={'-0.432px'}>
            {displayName}
          </TextV2>
        </Flex>
      </Flex>
    </Flex>
  );
};

HotelTile.displayName = 'HotelTile';

export { HotelTile };
